module.exports = __webpack_public_path__ + "img/home_black.b8ddcc58.png";